module.exports = __webpack_public_path__ + "img/illustration_home_map.b24b404c.svg";